import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, CheckCircle2Icon } from 'lucide-react';
// Product thumbnail (pomito tipo gotero + jengibre). Swap this URL if needed.
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/r571Vr3NiH48vVauDJmbox/Mockut_del_e_book.png';
type Notice = {
  name: string;
  city: string;
  minsAgo: number;
};
const NOTICES: Notice[] = [{
  name: 'María José',
  city: 'Bogotá',
  minsAgo: 3
}, {
  name: 'Valentina',
  city: 'Ciudad de México',
  minsAgo: 7
}, {
  name: 'Camila',
  city: 'Lima',
  minsAgo: 2
}, {
  name: 'Sofía',
  city: 'Buenos Aires',
  minsAgo: 11
}, {
  name: 'Daniela',
  city: 'Santiago',
  minsAgo: 5
}, {
  name: 'Lucía',
  city: 'Madrid',
  minsAgo: 9
}, {
  name: 'Andrea',
  city: 'Guayaquil',
  minsAgo: 4
}];
const VISIBLE_MS = 5500;
const GAP_MS = 24000; // long pause so notices don't appear too often
const FIRST_DELAY_MS = 7000;
export function SocialToast() {
  const [current, setCurrent] = useState<Notice | null>(null);
  const indexRef = useRef(0);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();
  useEffect(() => {
    let cancelled = false;
    const showNext = () => {
      if (cancelled) return;
      const next = NOTICES[indexRef.current % NOTICES.length];
      indexRef.current += 1;
      setCurrent(next);
      timeoutRef.current = setTimeout(() => {
        if (cancelled) return;
        setCurrent(null);
        timeoutRef.current = setTimeout(showNext, GAP_MS);
      }, VISIBLE_MS);
    };
    timeoutRef.current = setTimeout(showNext, FIRST_DELAY_MS);
    return () => {
      cancelled = true;
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
  const dismiss = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setCurrent(null);
    timeoutRef.current = setTimeout(() => {
      setCurrent(NOTICES[indexRef.current % NOTICES.length]);
      indexRef.current += 1;
      timeoutRef.current = setTimeout(() => setCurrent(null), VISIBLE_MS);
    }, GAP_MS);
  };
  return <div className="fixed bottom-4 left-3 right-3 sm:left-5 sm:right-auto z-[150] pointer-events-none" data-id="element-515">
      <AnimatePresence data-id="element-516">
        {current && <motion.div key={`${current.name}-${indexRef.current}`} initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="pointer-events-auto relative flex items-center gap-3 bg-forest border border-cream/15 rounded-2xl shadow-2xl pl-3 pr-9 py-3 w-full sm:w-auto sm:max-w-[330px]" role="status" aria-live="polite" data-id="element-517">
            <div className="shrink-0 w-14 h-14 rounded-xl overflow-hidden bg-cream/5 border border-cream/10" data-id="element-518">
              <img src={PRODUCT_IMAGE} alt="Libre de Endodolor" className="w-full h-full object-cover" data-id="element-519" />
            </div>
            <div className="min-w-0" data-id="element-520">
              <p className="text-cream text-sm leading-snug" data-id="element-521">
                <span className="font-semibold" data-id="element-522">{current.name}</span> de{' '}
                {current.city}
              </p>
              <p className="text-sand/80 text-xs leading-snug flex items-center gap-1.5 mt-0.5" data-id="element-523">
                <CheckCircle2Icon className="w-3.5 h-3.5 text-peach shrink-0" data-id="element-524" />
                acaba de obtener su ebook
              </p>
              <p className="text-sand/50 text-[11px] mt-1" data-id="element-525">
                hace {current.minsAgo} min · compra verificada
              </p>
            </div>
            <button onClick={dismiss} aria-label="Cerrar notificación" className="absolute top-2.5 right-2.5 text-sand/50 hover:text-cream transition-colors" data-id="element-526">
              <XIcon className="w-4 h-4" data-id="element-527" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}